import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookReportActionMaintenanceOperationalRestrictionTab extends Component {
  constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          action_parts_modal: false,
          maintenance_operational_restriction_name: null,
          report_action_id: this.props.report_action_id,
          type_field: 'select',
          limit_type: 0,
          reports: {},
          report_actions: {},
          report_action_deferred_items: [],
          maintenance_operational_restriction_list: [],
          maintenance_operational_restrictions: '',
          filtered_options: [
            {"value": 1, "label": "Data"},
          ],
          full_options: [
            {"value": 0, "label": "Sem limitação"},
            {"value": 1, "label": "Data"},
            {"value": 2, "label": "Horas de voo"},
            {"value": 3, "label": "Pousos"},
            {"value": 4, "label": "Específico"}
          ],
        };
        this.add = this.add.bind(this);
        this.deleteDeferredItem = this.deleteDeferredItem.bind(this);

      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }
      
      handleMultiSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event;
        }
        this.setState(change);
      }

      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = 1;
        } else {
          var value = 0;
        }
        change[name] = value;
        this.setState(change);
      }

      changeInput(type_field) {
        this.setState({
          type_field: type_field,
        });
      }

      // LM
      componentWillReceiveProps(newProps) {
        // Sempre atualiza o id da ação atual
        const incomingActionId = newProps.report_action_id;
        const deferredMap = newProps.report_action_deferred_items || {};

        this.setState({
          loaded: 1,
          report_action_id: incomingActionId,
          reports: typeof newProps.reports !== 'undefined' && newProps.reports !== null ? newProps.reports : this.state.reports,
          report_actions: typeof newProps.report_actions !== 'undefined' && newProps.report_actions !== null ? newProps.report_actions : this.state.report_actions,
          report_action_deferred_items: typeof deferredMap[incomingActionId] !== 'undefined' && deferredMap[incomingActionId] !== null ? deferredMap[incomingActionId] : [],
          maintenance_operational_restriction_list: typeof newProps.maintenance_operational_restriction_list !== 'undefined' && newProps.maintenance_operational_restriction_list !== null ? newProps.maintenance_operational_restriction_list : this.state.maintenance_operational_restriction_list,
        });
      }
      
      // Fetch salvando a ação
      add(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_report_action_id: this.state.report_action_id,
          type: this.state.type,
          type_field: this.state.type_field,
          item_number: this.state.item_number,
          mel: this.state.mel,
          category: this.state.category,
          limit_type: this.state.limit_type,
          limit: this.state.limit,
          limit_date: this.state.limit_date,
          limit_hour: this.state.limit_hour,
          limit_landing: this.state.limit_landing,
          description: this.state.description,
          reason: this.state.reason,
          correlation_analysis: this.state.correlation_analysis,
          maintenance_operational_restrictions: this.state.maintenance_operational_restrictions,
          maintenance_operational_restriction_name: this.state.maintenance_operational_restriction_name,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/item/acao/adiada', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              type: '',
              item_number: '',
              mel: '',
              category: '',
              limit: '',
              limit_date: '',
              limit_hour: '',
              limit_landing: '',
              description: '',
              reason: '',
              correlation_analysis: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      deleteDeferredItem(id) {
        if (!window.confirm('Tem certeza que deseja excluir este item adiado?')) {
          return;
        }
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/item/acao/adiada/' + id, { method: 'DELETE', mode: 'cors', headers: value })
            .then((response) => response.json())
            .catch((error) => { console.error(error); })
            .then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            })
            .catch((error) => { console.error(error); });
        });
      }
    
      render() {
        var self = this;
        return (
      <div>
      <RequestApi ref={'request_api'} />
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Type</label>
                <Select
                  className="form-group"
                  name="type"
                  value={this.state.type}
                  searchable={true}
                  placeholder={'Selecionar'}
                  onChange={this.handleSelectChange.bind(this, 'type')}
                  options={[
                    {value: 0, label: "MEL"},
                    {value: 1, label: "NEF"},
                  ]}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>N° Item</label>
                <input type="text" className="form-control" value={this.state.item_number} name="item_number" onChange={this.handleChange.bind(this, 'item_number')} placeholder="N° Item" required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Categoria</label>
                <Select
                  className="form-group"
                  name="category"
                  value={this.state.category}
                  searchable={true}
                  placeholder={'Selecionar'}
                  onChange={this.handleSelectChange.bind(this, 'category')}
                  options={[
                    {value: "a", label: "A"},
                    {value: "b", label: "B"},
                    {value: "c", label: "C"},
                    {value: "d", label: "D"},
                  ]}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Tipos de limite</label>
                <Select
                  className="form-group"
                  name="limit_type"
                  value={this.state.limit_type}
                  searchable={true}
                  placeholder={'Selecionar'}
                  onChange={this.handleSelectChange.bind(this, 'limit_type')}
                  options={this.state.category === 'a' ? this.state.full_options : this.state.filtered_options}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            {this.state.type == 0 ? 
              <div className="col-md-6">
                <div className="form-group">
                  <label>MEL</label>
                  <input type="text" className="form-control" value={this.state.mel} name="mel" onChange={this.handleChange.bind(this, 'mel')} placeholder="MEL" required />
                </div>
              </div>
            : ''            
            }
            {(this.state.limit_type == 1 && this.state.category !== 'a') || this.state.limit_type == 0 ? 
              ''
              :
              <div className="col-md-6">
                <div className="form-group">
                  <label>Limite</label>
                    <input type="number" className="form-control" value={this.state.limit} name="limit" onChange={this.handleChange.bind(this, 'limit')} placeholder="Limite" required />
                </div>
              </div>
            }
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Descrição</label>
                <input type="text" className="form-control" value={this.state.description} name="description" onChange={this.handleChange.bind(this, 'description')} placeholder="Descrição" required />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Motivo</label>
                <input type="text" className="form-control" value={this.state.reason} name="reason" onChange={this.handleChange.bind(this, 'reason')} placeholder="Motivo" required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Análise de correlação</label>
                <Select
                  className="form-group"
                  name="correlation_analysis"
                  value={this.state.correlation_analysis}
                  searchable={true}
                  placeholder={'Selecionar'}
                  onChange={this.handleSelectChange.bind(this, 'correlation_analysis')}
                  options={[
                    {value: "0", label: "N/A"},
                    {value: "1", label: "Satisfatório"},
                  ]}
                  required
                />
              </div>
            </div>
            {this.state.type_field === 'input' ?  
              <div className="col-md-6">
                <div className="form-group">
                  <label>Nova Restrições Operacional: <button type="button" onClick={() => {self.changeInput('select')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-refresh"></i></button></label>
                  <input type="text" name="maintenance_operational_restriction_name" className="form-control" placeholder="" value={this.state.maintenance_operational_restriction_name} onChange={this.handleChange.bind(this, 'maintenance_operational_restriction_name')} required/>
                </div>
              </div>
            : 
              <div className="col-md-6">
                <div className="form-group">
                  <label>Restrições Operacionais <button type="button" onClick={() => {self.changeInput('input')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-plus"></i></button></label>
                    <Select
                      className="form-group"
                      name="maintenance_operational_restrictions"
                      value={this.state.maintenance_operational_restrictions}
                      searchable={true}
                      placeholder={'Restrições Operacionais'}
                      multi={true}
                      onChange={this.handleMultiSelectChange.bind(this, 'maintenance_operational_restrictions')}
                      options={this.state.maintenance_operational_restriction_list}
                    />
                </div>
              </div>    
            }
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
              </div>
            </div>
          </div>
        </form>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Deferred Items</caption>
            <thead>
              <tr>
                <th className="text-center vcenter">Type</th>
                <th className="text-center vcenter">N° Item</th>
                <th className="text-center vcenter">Categoria</th>
                <th className="text-center vcenter">Tipo de limite</th>
                <th className="text-center vcenter">MEL</th>
                <th className="text-center vcenter">Limite</th>
                <th className="text-center vcenter">Descrição</th>
                <th className="text-center vcenter">Motivo</th>
                <th className="text-center vcenter">Análise de correlação</th>
                <th className="text-center vcenter">Restrições operacionais</th>
                <th className="text-center vcenter">Ações</th>
              </tr>
            </thead>
            <tbody id="deferred_items">
            {self.state.report_action_deferred_items.map(function(k) {
              var deferred_item = k;
              return(
                <tr className="text-center" key={deferred_item.id}>
                  <td>{deferred_item.type_str}</td>
                  <td>{deferred_item.item_number}</td>
                  <td>{deferred_item.category}</td>
                  <td>{deferred_item.limit_type_str}</td>
                  <td>{deferred_item.mel}</td>
                  <td>{deferred_item.limit}</td>
                  <td>{deferred_item.description}</td>
                  <td>{deferred_item.reason}</td>
                  <td>{deferred_item.correlation_analysis_str}</td>
                  <td>{deferred_item.maintenance_operational_restriction}</td>
                  <td>
                    <button onClick={() => self.deleteDeferredItem(deferred_item.id)} className="btn btn-danger btn-sm">
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AircraftLogbookReportActionMaintenanceOperationalRestrictionTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookReportActionMaintenanceOperationalRestrictionTab.js